import { render, staticRenderFns } from "./HeadToHead.vue?vue&type=template&id=6737af94&scoped=true&"
import script from "./HeadToHead.vue?vue&type=script&lang=js&"
export * from "./HeadToHead.vue?vue&type=script&lang=js&"
import style0 from "./HeadToHead.vue?vue&type=style&index=0&id=6737af94&scoped=true&lang=css&"
import style1 from "./HeadToHead.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6737af94",
  null
  
)

export default component.exports